import {useQuery} from 'react-query';

import {getNearestStores} from '.';

export const useGetNearestStores = (payload: INearestParams) => {
  const {data, isLoading} = useQuery(['get-nearest-stores', payload], () =>
    getNearestStores(payload),
  );

  return {nearestStores: data, nearestStoresIsLoading: isLoading};
};
